export default "__VITE_ASSET__OYlazuzz__"